import { InjectionToken } from '@angular/core';
import { ClientEnvironment } from './client-environment.model';

export const CLIENT_ENVIRONMENT_PROVIDER = new InjectionToken<ClientEnvironment>(
  'clientEnvironmentProvider'
);
